import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';


export const useHistoryManagement = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      const currentPath = location.pathname;

      if (user && location.pathname.includes('/auth')) {
        event.preventDefault();

        navigate('/', { replace: true });
      }
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [location.pathname, user, navigate]);

  useEffect(() => {
    if (localStorage.getItem('justLoggedIn')) {
      const timer = setTimeout(() => {
        localStorage.removeItem('justLoggedIn');
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);
};
